import { Navigate, useLocation } from "react-router-dom";
import { useUserStore } from "entities/user";

export const RequireAuth = ({ children }) => {
  const location = useLocation();
  const { isAuthenticated } = useUserStore();

  if (!isAuthenticated) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  return children;
};
